import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { CustomDateParserFormatter } from '../shared/adapters/datepicker-adapter';
import { devices } from './shared/models/devices.model';

import { DevicesService } from './shared/services/devices.service';

@Component({
  selector: 'app-devices',
  templateUrl: './devices.component.html',
  styleUrls: ['./devices.component.css'],
  providers: [
    { provide: NgbDateParserFormatter, useClass: CustomDateParserFormatter }
  ]
})
export class DevicesComponent implements OnInit {
  pageNo: number =1;
  pageSize: number = 10;
  devices:any;
  viewModel: any;
  assignDate : NgbDateStruct;
  tosterMessage: string = 'Save Successfully';
  @ViewChild("device_form") device_form : NgForm;

  constructor(public _devicesSvc: DevicesService, private _toasterSvc: ToastrService) { }

  ngOnInit() {
    let today = new Date();
    // this.assignDate = null;
    this.assignDate = { year: today.getFullYear(), month: today.getMonth() + 1, day: today.getDate() }
     this.GetDevices(this.pageNo);
     this.GetDrivers();
  }

  GetDevices(pageNo){
    this._devicesSvc.GetDevices(pageNo, this.pageSize).subscribe(response => {
      this.devices = response;
    });
  
  // console.log(this._devicesSvc);
  }

  GetDrivers(){
    this._devicesSvc.GetDrivers().subscribe(response => {
      this.viewModel = response;
      //console.log(response)
    });
    // console.log(this._devicesSvc);
  }

  saveDevice(){
    // debugger;
    this.viewModel.Device.assignDate = (this.assignDate.month + '/' + this.assignDate.day + '/' + this.assignDate.year).toString();
    this._devicesSvc.postDevice(this.viewModel).subscribe(response => {
      
      if(response){
        this.GetDevices(this.pageNo);
        this.device_form.resetForm();
        this._toasterSvc.success(this.tosterMessage);
        this.ngOnInit();
      }
      else{
        this._toasterSvc.error("Error");

      }
  
    }); 
    this.viewModel.reset();
    this.viewModel = null;
  }

  edit(mod){
    console.log(mod);

    let tempDate = new Date(mod.AssignDate);
    this.viewModel.Device = Object.assign({}, mod);
    this.viewModel.Device.DriverId = mod.DriverId;
    this.viewModel.Device.Type = mod.Type;
    this.assignDate = {year: tempDate.getFullYear(), month: (tempDate.getMonth() + 1), day: tempDate.getDate()}; 
    this.tosterMessage = 'Update Successfully';
  }
 

}
